
export default {
  title: "隐私政策",
  subtitle: "我们重视您的隐私，致力于保护您的个人信息安全",
  lastUpdated: "最后更新时间：2024年1月15日",
  // 使用转义字符避免字符串内部的双引号导致语法错误
  intro: "Deriway（\"我们\"、\"公司\"）尊重并保护用户的隐私权。本隐私政策说明我们如何收集、使用、存储和保护您的个人信息。",

  section1: {
    title: "1. 信息收集",
    personalInfo: "个人身份信息：姓名、邮箱地址、电话号码、身份证件信息等",
    transactionInfo: "交易信息：支付记录、交易历史、账户余额等",
    technicalInfo: "技术信息：IP地址、设备信息、浏览器类型、操作系统等",
    usageInfo: "使用信息：服务使用记录、偏好设置、操作日志等"
  },

  section2: {
    title: "2. 信息使用",
    item1: "• 提供和改进我们的金融服务",
    item2: "• 验证用户身份，防范欺诈和洗钱",
    item3: "• 处理交易和支付请求",
    item4: "• 发送重要通知和服务更新",
    item5: "• 遵守法律法规和监管要求",
    item6: "• 进行风险评估和合规审查"
  },

  section3: {
    title: "3. 信息共享",
    intro: "我们不会出售、租赁或交易您的个人信息。仅在以下情况下共享：",
    item1: "• 获得您的明确同意",
    item2: "• 法律法规要求或政府部门要求",
    item3: "• 与可信的第三方服务提供商合作（如支付处理商）",
    item4: "• 保护我们的合法权益或防范欺诈"
  },

  section4: {
    title: "4. 数据安全",
    item1: "• 采用行业标准的加密技术保护数据传输",
    item2: "• 实施严格的访问控制和权限管理",
    item3: "• 定期进行安全审计和漏洞扫描",
    item4: "• 遵循PCI DSS等安全标准",
    item5: "• 建立完善的数据备份和恢复机制"
  },

  section5: {
    title: "5. 您的权利",
    accessRight: "• 访问权：查看我们持有的您的个人信息",
    correctionRight: "• 更正权：要求更正不准确的个人信息",
    deletionRight: "• 删除权：在特定情况下要求删除个人信息",
    restrictionRight: "• 限制处理权：限制我们处理您的个人信息",
    portabilityRight: "• 数据可携权：以结构化格式获取您的数据"
  },

  section6: {
    title: "6. Cookie政策",
    intro: "我们使用Cookie和类似技术来：",
    item1: "• 记住您的登录状态和偏好设置",
    item2: "• 分析网站使用情况，改进用户体验",
    item3: "• 提供个性化内容和广告",
    item4: "• 确保网站安全和防范欺诈"
  },

  section7: {
    title: "7. 数据保留",
    intro: "我们仅在必要期间保留您的个人信息：",
    item1: "• 提供服务所需的期间",
    item2: "• 法律法规要求的保留期间",
    item3: "• 解决争议和执行协议所需的期间",
    item4: "• 满足监管要求的期间"
  },

  section8: {
    title: "8. 国际数据传输",
    intro: "您的个人信息可能被传输到您所在国家/地区以外的地方进行处理。我们将：",
    item1: "• 确保接收方提供充分的数据保护",
    item2: "• 签署标准合同条款或其他法律机制",
    item3: "• 遵守适用的数据保护法律"
  },

  section9: {
    title: "9. 政策更新",
    intro: "我们可能会不时更新本隐私政策。重大变更时，我们将：",
    item1: "• 在网站上发布更新通知",
    item2: "• 通过邮件或其他方式通知您",
    item3: "• 在法律要求时获得您的同意"
  },

  section10: {
    title: "10. 联系我们",
    intro: "如果您对本隐私政策有任何疑问或需要行使您的权利，请联系我们：",
    email: "• 邮箱：support@deriway.com",
    telegram: "• Telegram：@deriway_business",
    response: "• 我们将在收到您的请求后及时回复"
  }
};
